<template>
  <div class='e-tab-wrap h-mmlTabs-content'>
    <CustomDialog ref='addDialog' :element="dialog.element.addDialogSetting"
                  :styles="dialog.element.addDialogSetting.styles">
      <template v-slot:dialog-content>
        <AddMMLTimeTask ref="mmlTimeContent"></AddMMLTimeTask>
      </template>
    </CustomDialog>

    <CustomDialog ref='exportDialog' :element="dialog.element.exportDialogSetting"
                  :styles="dialog.element.exportDialogSetting.styles">
      <template v-slot:dialog-content>
        <MoTreeCheck  ref="exportContent"></MoTreeCheck>
      </template>
    </CustomDialog>
    <div class='h-mml-scnrbox'>
      <form :id='formId'>
        <div class='form-group'>
          <label>{{$t('MML.fileName')}}</label>
          <div class='h-mml-upload'>
            <ejs-textbox v-model='fileName' name='mml-uadform-input' :placeholder='curPlaceholder' width='400px'></ejs-textbox>
            <div class='h-mml-upload-area'>
              <template v-if='showUPLD'>
                <div>
                  <ejs-uploader :autoUpload= 'isAuto' :id='uploadId' @selected='onFileSelect'
                    :allowedExtensions='extensions' :multiple='false' ></ejs-uploader>
                  <button type='button' class='e-control e-btn e-primary' @click="uploadFile">{{$t('MML.selectFileButton')}}</button>
                </div>
              </template>
            </div>
          </div>
        </div>
        <div v-show='showEtcNeType' class='form-group'>
          <label>{{$t('MML.neType')}}</label>
          <div>
            <ejs-dropdownlist v-model='etcType' name='mml-etc-type' :fields='fields' :dataSource='type' width='400px'></ejs-dropdownlist>
          </div>
        </div>
        <div v-show='showEtcNeType' class='form-group'>
          <label>{{$t('MCS.importType')}}</label>
          <div>
            <ejs-dropdownlist v-model='dldTypeStr' name='mml-dld-type' :fields='fields' :dataSource='dldType' width='400px'></ejs-dropdownlist>
          </div>
        </div>
        <div v-show='showEnbNeType' class='form-group'>
          <label>{{$t('MML.neType')}}</label>
          <div>
            <ejs-dropdownlist v-model='enbType' name='mml-enb-type' :fields='fields' :dataSource='type' width='400px'></ejs-dropdownlist>
          </div>
        </div>
        <div v-show='showMicroType' class='form-group'>
          <label>{{$t('MML.instanceId')}}</label>
          <div>
            <ejs-textbox v-model='microServiceId' name='mml-micro-type' width='400px'></ejs-textbox>
          </div>
        </div>
      </form>
    </div>
    <div class='h-input-btns'>
      <ejs-button  v-show='showExportButton' class='e-btn e-control e-primary' :disabled='this.mmlOperButtonDisabled'
                  v-on:click.native='showExport'>{{$t('System.batchImport')}}
      </ejs-button>
      <ejs-button v-show='showTimeExecButton' class='e-btn e-control e-primary' :disabled='this.mmlOperButtonDisabled'
                  v-on:click.native='showMMLTimeTask'>{{$t('MML.executeTime')}}
      </ejs-button>
      <ejs-button  class='e-btn e-control e-primary' :disabled='this.mmlOperButtonDisabled' v-on:click.native='execMML'>{{$t('MML.execute')}}</ejs-button>
      <ejs-button  class='e-btn e-control e-primary' :disabled='this.mmlOperButtonDisabled' v-on:click.native='generateMML2Cmd'>{{$t('MML.buildMML')}}</ejs-button>
    </div>
  </div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex';
import { FormValidator } from '@syncfusion/ej2-inputs';
import packageParams from '@/components/mmlconfig/mixins/packageParams';
import {EventBus} from '@/plugins/eventBus.js';
import bus from '../bus.js';
import AddMMLTimeTask from './AddMMLTimeTask';
import CustomDialog from '../../common/CustomDialog';
import MoTreeCheck from '@/components/mmlconfig/midPanel/MoTreeCheck.vue';

const { mapGetters, mapMutations } = createNamespacedHelpers('mmlconfig');
export default ({
  components: {
    CustomDialog,
    AddMMLTimeTask,
    MoTreeCheck
  },
  data() {
    return {
      showExportButton:false,
      showTimeExecButton:false,
      execTime: 0,
      extensions: '.txt',
      isAuto: false,
      fields: { text: 'name', value: 'value' },
      fileName: '',
      etcType: '',
      dldTypeStr: '',
      enbType: '',
      microServiceId: '',
      formObj: '',
      type: [],
      dldType:[],
      showEnbNeType: false,
      showEtcNeType: false,
      showMicroType: false,
      curPlaceholder: '',
      showUPLD: false,
      options: {
        customPlacement: (inputElement, errorElement) => {
          const parentElement = inputElement.closest('.form-group');
          parentElement.appendChild(errorElement);
        },
        rules: {
          'mml-uadform-input': {
            required: [true, this.$t('MML.notNull')],
            maxLength: [255, this.$t('MML.maxLength', [255])]
          }
        }
      },
      dialog: {
        element: {
          addDialogSetting: {
            styles: {
              width: '600px',
              height: '250px',
              model: true,
              visible: false
            },
            target: '#app',
            title: this.$t('MML.executeTime'),
            refName: 'add',
            isClose: true,
            buttonGroup: [
              {click: this.dialogHide, buttonModel: {content: this.$t('Observe.cancel')}},
              {click: this.execMMLTime, buttonModel: {content: this.$t('Observe.confirm'), isPrimary: true}}
            ]
          },
          exportDialogSetting: {
            styles: {
              width: '600px',
              height: '700px',
              model: true,
              visible: false
            },
            target: '#app',
            title: '批量导出',
            refName: 'export',
            isClose: true,
            buttonGroup: [
              {click: this.dialogExportHide, buttonModel: {content: this.$t('Observe.cancel')}},
              {click: this.execExport, buttonModel: {content: this.$t('Observe.confirm'), isPrimary: true}}
            ]
          }
        }
      },
    };
  },
  props: {
    formName: {
      type: String,
      default() {
        return '';
      },
    },
  },
  mixins: [packageParams],
  mounted() {
    console.log('------mounted------')
    this.formObj = new FormValidator(`#${this.formId}`, this.options);
  },
  computed: {
    ...mapGetters(['currentNode', 'currentMo', 'currentCommand', 'mmlOperButtonDisabled']),
    // curPlaceholder() {
    //   return this.currentCommand.name === 'DLD' ? this.$t('MML.selectFile') : this.$t('MML.inputFileName');
    // },
    // showUPLD() {
    //   return this.currentCommand.name.toUpperCase() === 'DLD';
    // },
    formId() {
      return `form4mml${this.formName}`;
    },
    inputId() {
      return `uadform${this.formName}`;
    },
    uploadId() {
      return `upload${this.formName}`;
    }
  },
  methods: {
    ...mapMutations(['changeCommand']),
    setInitParams(mo, command) {
      console.log("setInitParams",command);
      this.formObj.element.reset();


      this.showEtcNeType = this.currentMo.moName === 'etcCfgData';

      this.showEnbNeType = this.currentMo.moName === 'eNodeBCfgData' || this.currentMo.moName === 'gNBCfgData';

      this.showMicroType = this.currentMo.moName.toLowerCase() === 'cfgdata';

      if (this.showEtcNeType) {
        this.type = this.getEtcType();
        this.dldType = this.getDldType();
        this.showExportButton = command.name.toUpperCase() === 'UPLD'
        this.showTimeExecButton = command.name.toUpperCase() === 'DLD'
      } else if (this.showEnbNeType){
        this.type = this.getEnbType();
        // ibsb没有类型字段
        if(this.type.length <= 0){
          this.showEnbNeType = false;
        }
      }
      if(this.showEtcNeType) {
        this.formObj.addRules('mml-etc-type', { required: [true, this.$t('MML.notNull')] });
        this.formObj.addRules('mml-dld-type', { required: [true, this.$t('MML.notNull')] });
      } else if (this.showEnbNeType) {
        this.formObj.addRules('mml-enb-type', { required: [true, this.$t('MML.notNull')] });
      } else if(this.showMicroType) {
        this.formObj.addRules('mml-micro-type', { required: [true, this.$t('MML.notNull')] });
      }
      this.curPlaceholder = command.name.toUpperCase() === 'DLD' ? this.$t('MML.selectFile') : this.$t('MML.inputFileName');
      this.showUPLD = command.name.toUpperCase() === 'DLD';
      this.changeCommand(command);
    },
    dialogHide() {
      this.$refs.addDialog.clear();
      this.$refs.addDialog.close();
    },
    dialogExportHide() {
      //this.$refs.exportDialog.clear();
      this.$refs.exportDialog.close();

    },
    showMMLTimeTask() {
      this.$refs.addDialog.show();
    },
    showExport() {
      this.$refs.exportDialog.show();
      //this.$refs.exportContent.reload();
      //console.log("showExport",sessionStorage.getItem("mmlTreeData"));

    },
    //批量导出
    execExport() {
      const checkedNodes = this.$refs.exportContent.getCheckNodes();
      if (this.$refs.exportContent.getCheckNodes().length == 0) {
        EventBus.$emit('toast', {type: 'warning', content: '未选择mo'});
        return ;
      }
      else {
        this.dialogExportHide();
        if (this.formObj.validate()) {
          const cmdList = this.genUadFormMML();
          // 执行逻辑在CommandExec组件中实现
          this.$emit('sync-time', 0);
          sessionStorage.setItem("mml_export_mos", JSON.stringify(checkedNodes));
          this.$emit('ready-to-exec', cmdList);
        } else {
          console.warn('mml表单校验不通过');
        }
      }
    },
    //定时执行
    execMMLTime() {
      this.dialogHide();
      this.execTime = this.$refs.mmlTimeContent.getFormData().executeTime;

      if (this.formObj.validate()) {
        const cmdList = this.genUadFormMML();
        // 执行逻辑在CommandExec组件中实现
        this.$emit('sync-time', this.execTime);
        this.$emit('ready-to-exec', cmdList);
      } else {
        console.warn('mml表单校验不通过');
      }
    },
    getEtcType() {
      const vals = [];
      try {
        const ranges = this.currentMo.attrMap.etcType.range;
        ranges.split(',').forEach((range) => {
          const tempVal = range.split(':');
          vals.push({
            name: tempVal[0].trim(),
            value: tempVal[0].trim()
          });
        });
      } catch (error) {
        console.warn('----etc type is undefined---');
      }
      return vals;
    },
    getDldType() {
      const vals = [];
      try {
        const ranges = this.currentMo.attrMap.dldType.range;
        ranges.split(',').forEach((range) => {
          const tempVal = range.split(':');
          vals.push({
            name: tempVal[0].trim(),
            value: tempVal[0].trim()
          });
        });
      } catch (error) {
        console.warn('----dldType is undefined---');
      }
      return vals;
    },
    getEnbType() {
      const vals = [];
      try {
        const ranges = this.currentMo.attrMap.neType.range;
        ranges.split(',').forEach((range) => {
          const tempVal = range.split(':');
          vals.push({
            name: tempVal[0].trim(),
            value: tempVal[0].trim()
          });
        });
      } catch (error) {
        console.warn('----enb type is undefined---');
      }
      return vals;
    },
    onFormSubmit() {
      const formStatus = this.formObj.validate();
      if (formStatus) {
        this.formObj.element.reset();
        this.$refs.dialogObj.show();
      }
    },
    onFileSelect(args) {
      // 上传文件逻辑
      const uploadUrl = '/lte/ems/config/mml/enodeBCfgDataUpLoad';
      const formData = new FormData();
      const uploadFile = document.getElementById(this.uploadId).files[0];
      formData.append('mFile', uploadFile);
      let neid;
      if (this.currentNode.nodeType === 'equipment') {
        neid = this.findEquipmentIpId(this.currentNode, this.currentMo);
      } else {
        neid = this.currentNode.id;
      }
      formData.append('neid', neid);
      formData.append('systemid', 1);
      const config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      };
      this.axios.post(uploadUrl, formData, config).then(res => {
        this.fileName = args.filesData[0].name;
      })
    },
    uploadFile() {
      document.getElementsByClassName('e-file-select-wrap')[0].querySelector('button').click();
      return false;
    },
    execMML() {
      console.log('readyToExec');
      console.log(this.options.rules);
      if (this.formObj.validate()) {
        const cmdList = this.genUadFormMML();
        this.$emit('ready-to-exec', cmdList);
      } else {
        console.warn('mml表单校验不通过');
      }
    },
    generateMML2Cmd() {
      //console.log("generateMML2Cmd",this.options.rules);
      if (this.formObj.validate()) {
        const cmdList = this.genUadFormMML();
        //console.log("generateMML2Cmd",cmdList)
        bus.$emit('add2CmdEditor', cmdList);
      } else {
        console.warn('mml表单校验不通过');
      }
    },
    genUadFormMML() {
      const cmdList = [];
      const params = this.generateFormParams();
      const mml = this.parseParams2MML(params);
      cmdList.push(mml);
      return cmdList;
    },
    generateFormParams() {
      const params = {};
      params.ftpServerFileName = this.fileName;
      if (this.showEtcNeType) {
        params.etcType = this.etcType;
        params.dldType = this.dldTypeStr;
      } else if (this.showEnbNeType) {
        params.neType = this.enbType;
      } else {
        params.serviceInstanceId = this.microServiceId;
      }
      return params;
    },
    parseParams2MML(params) {
      console.log("parseParams2MML",params)
      // 匹配数值  "" ^\\d+(\.\\d+)?$
      const numberExp = new RegExp('^-?\\d+(\\.\\d+)?$');
      let mml = `${this.currentCommand.name} ${this.currentMo.moName} :`;
      if (this.currentNode) {
        mml += ` ne= ${this.currentNode.id} ,`;
      }
      // if (this.currentNode.nodeType === 'equipment') {
      //   const equipmentIpId = this.findEquipmentIpId(this.currentNode, this.currentMo);
      //   mml += ` equipmentIpId= ${equipmentIpId} ,`;
      // }
      Object.keys(params).forEach(param => {
        if (params[param] !== '') {
          if (numberExp.test(params[param]) || params[param] === 'null' || params[param] === '"null"') {
            mml += ` ${param} = ${params[param]},`;
          } else {
            mml += ` ${param} = "${params[param]}",`;
          }
        }
      });
      return `${mml.substring(0, mml.length - 1).trim()} ;`;
    },
  }
});
</script>
<style>

</style>
